class VideoTabReadMore extends HTMLElement {
  #content;
  #excerpt;
  #fullContent;
  #trigger;
  #label;
  #readMoreText;
  #readLessText;

  connectedCallback() {
    this.#content = this.querySelector('[data-content]');
    this.#excerpt = this.querySelector('[data-excerpt]');
    this.#fullContent = this.querySelector('[data-full-content]');
    this.#trigger = this.querySelector('[data-read-more-trigger]');
    this.#label = this.querySelector('[data-read-more-label]');

    if (!this.#trigger || !this.#fullContent || !this.#content) return;

    this.#readMoreText = this.#label.textContent;
    this.#readLessText = this.getAttribute('data-read-less-text') || 'Read less';

    this.#trigger.addEventListener('click', this.#handleToggle);

    // No initial max-height lock — the excerpt renders at its natural
    // height with nothing clipping it until the user actually toggles.

    this.#trigger.addEventListener('click', this.#handleToggle);
    this.#content.addEventListener('transitionend', this.#handleTransitionEnd);
  }

  disconnectedCallback() {
    this.#trigger?.removeEventListener('click', this.#handleToggle);
    this.#content?.removeEventListener('transitionend', this.#handleTransitionEnd);
  }

  #handleToggle = () => {
    const isExpanded = this.#trigger.getAttribute('aria-expanded') === 'true';

    // Lock the CURRENT rendered height as the animation start point.
    // Measured live, so it's always accurate to loaded fonts/images.
    this.#content.style.maxHeight = `${this.#content.offsetHeight}px`;
    // Force the browser to apply that value before changing anything else.
    this.#content.offsetHeight; // eslint-disable-line no-unused-expressions

    if (isExpanded) {
      this.#fullContent.hidden = true;
      if (this.#excerpt) this.#excerpt.hidden = false;
    } else {
      this.#fullContent.hidden = false;
      if (this.#excerpt) this.#excerpt.hidden = true;
    }

    // Next frame: set the real target height so the transition animates toward it.
    requestAnimationFrame(() => {
      const target = isExpanded ? this.#excerpt.offsetHeight : this.#fullContent.scrollHeight;
      this.#content.style.maxHeight = `${target}px`;
    });

    this.#trigger.setAttribute('aria-expanded', String(!isExpanded));
    this.#label.textContent = isExpanded ? this.#readMoreText : this.#readLessText;
  };

  #handleTransitionEnd = (event) => {
    if (event.target !== this.#content || event.propertyName !== 'max-height') return;
    // After expanding, release the fixed height so any later reflow
    // (resize, dynamic content) never re-introduces clipping.
    if (this.#trigger.getAttribute('aria-expanded') === 'true') {
      this.#content.style.maxHeight = 'none';
    }
  };
}

if (!customElements.get('video-tab-read-more')) {
  customElements.define('video-tab-read-more', VideoTabReadMore);
}